<script>
import {BLink} from 'bootstrap-vue'
export default {
    components: {BLink},
    props: {
        id: {
            required: true,
        },
        ce: {
            required: true
        }
    },
    computed: {
        isCategoryMissing() {
            return !(this.ce.details.mixtureCategory || this.ce.details.materialCategory)
        }
    }
}
</script>

<template>
    <div :class="{'ce-list': true, 'input-bg-warning': isCategoryMissing}">
        <span>{{ ce.substance.title }}</span>
        <span v-if="ce.details.concentrationRange">{{ce.details.concentrationRange.title}}</span>
        <span v-if="ce.details.materialCategory">{{ce.details.materialCategory.title}}</span>
        <span v-if="ce.details.additionalMaterial">{{ce.details.additionalMaterial.title}}</span>
        <span v-if="ce.details.mixtureCategory">{{ce.details.mixtureCategory.title}}</span>
        <span v-if="isCategoryMissing" class="text-danger error">
            {{ $t('Page(SCIPPreview):Component(WarningText):substance-category-missing') }}
            <b-link target="_blank" :to="{name: 'product-card', params: {id: id}}">
                {{ $t('Page(SCIPPreview):Component(Link):goto-product') }}
            </b-link>
        </span>
    </div>
</template>

<style scoped lang="scss">
.ce-list {
    span:not(:last-child)::after {
        content: ", ";
    }
    .error {
        font-weight: bold;
    }
}
</style>
